import React from "react"
import classNames from "classnames"
import Icon from "../../../../components/Icon/Icon"
import BodyPortal from "../../../../components/BodyPortal/BodyPortal"
import ReactTooltip from "react-tooltip"
import {EditMode} from "../../../../resources/common"
import {InterestTieringMode} from "../../../../resources/depositProduct"

interface CalculationTypeSelectorProps {
	value: InterestTieringMode
	onChange: (value: InterestTieringMode) => void
	editMode: EditMode
	isDisabled?: boolean
}

const TOOLTIP_TEXT = `<strong style="color: white;">Blended</strong> - Each portion of the balance earns the rate of its tier.<br/><strong style="color: white;">Whole</strong> - The entire balance earns the rate of the tier it falls into.`

export default function CalculationTypeSelector({
	value,
	onChange,
	editMode,
	isDisabled = false,
}: CalculationTypeSelectorProps) {
	const isViewMode = editMode === EditMode.VIEW
	const controlsDisabled = isViewMode || isDisabled

	return (
		<div className="calculation-type-selector">
			<span className="label-text">Calculation Type</span>
			<Icon data-tip={TOOLTIP_TEXT} data-html={true} icon={"information-circle--interface-essential"} size={16} />
			<BodyPortal>
				<ReactTooltip type="dark" effect="solid" className={"tooltip-info"} html={true} />
			</BodyPortal>
			<div className="segmented-buttons">
				<button
					type="button"
					className={classNames("segmented-button", value === "Blended" && "is-active")}
					onClick={() => !controlsDisabled && onChange("Blended")}
					disabled={controlsDisabled}
				>
					Blended
				</button>
				<button
					type="button"
					className={classNames("segmented-button", value === "Whole" && "is-active")}
					onClick={() => !controlsDisabled && onChange("Whole")}
					disabled={controlsDisabled}
				>
					Whole
				</button>
			</div>
		</div>
	)
}
